'use client';

import React from 'react';
import { saveAs } from 'file-saver';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

type Props = {
  title: string;
  datasets: any;
};

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function LineChart({ title, datasets }: Props) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Detail Report History',
      },
      zoom: {
        pan: {
          enabled: true,
          mode: 'x',
        },
        zoom: {
          pinch: {
            enabled: true, // Enable pinch zooming
          },
          wheel: {
            enabled: true, // Enable wheel zooming
          },
          mode: 'x',
        },
      },
    },
  };

  const saveCanvas = () => {
    //save to png
    const canvasSave = document.getElementById(`chart-${title.replaceAll(' ', '-')}`);
    if (canvasSave === null) return;
    //@ts-ignore
    canvasSave.toBlob(function (blob) {
      saveAs(blob, `chart-${title.replaceAll(' ', '-')}.png`);
    });
  };

  return (
    <>
      <a onClick={() => saveCanvas()} className="text-blue-500 hover:underline cursor-pointer">
        Download as PNG
      </a>

      <div className="mt-4">
        <Line id={`chart-${title.replaceAll(' ', '-')}`} options={options} data={datasets} />
      </div>
    </>
  );
}
